import Leads from "./leads"

export default Leads
